
    <div class="btn-group btn-group-toggle  {{inline ? 'mb-1' : 'd-block'}}" data-toggle="buttons">
        <button class="btn {{inline ? 'btn-sm' : ''}} btn-secondary {{value ? 'active' : ''}}" [disabled]="disabled" (click)="handleClick(true)">
            {{ enableText }}
        </button>
        <button class="btn {{inline ? 'btn-sm' : ''}} btn-secondary {{value ? '' : 'active'}}" [disabled]="disabled" (click)="handleClick(false)">
            {{ disableText }}
        </button>
    </div>
  